import { MediaDeviceManager, VoipMediaState } from 'utils/ui/media';
import { userSession } from './session';
import { isDebugMode } from 'utils/ui/debug';
import logger from 'utils/log';

let state: MediaDeviceManager;

let lastId: string | undefined;

export function myCameraStream() {
  if (lastId !== userSession().get('id')) {
    // restart media manager for each 3d exhibition session to allow proper cleanup
    state?.destroy();
    state = undefined!;
  }

  if (!state) {
    state = new MediaDeviceManager();

    lastId = userSession().get('id');

    state.once('before-initialized', () => {
      if (!userSession().voipEnabled) {
        // Do not allow audio/video to start unless we are using remote session
        return false;
      }
    });

    state.once('initialized', () => {
      userSession().once('session:end', () => {
        state.enableTrack('audio', false);
        state.enableTrack('video', false);
        state.destroy();

        // dump instance to allow garbage collection
        // this looks like the reset from a few lines above, but they don't always duplicate
        state = undefined!;
      });
    });
  }
  return state;
}

/**
 * Retrieve the current state of camera and mic. Note that within this function, the state is only read, but not modified in any way.
 * @returns if present and for the current session, an object with microphoneEnabled and cameraEnabled booleans
 */
export function voipMediaState(): VoipMediaState | undefined {
  if (!state || state.get('isAudioEnabled') === undefined || state.get('isVideoEnabled') === undefined) {
    logger.warn('Camera and microphone are not initialized.');
    return;
  }

  if (lastId !== userSession().get('id')) {
    logger.warn('Camera and microphone state does not belong to the current session.');
    return;
  }

  return {
    microphoneEnabled: state.get('isAudioEnabled'),
    cameraEnabled: state.get('isVideoEnabled'),
  };
}

if (isDebugMode()) {
  window.myCameraStream = myCameraStream;
}
